import React from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import PageLayout from "../../layouts/PageLayout";

const ContainerBling = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: calc(100vh - 300px);
	padding: 2rem;
`;

const ConteudoCentralizado = styled.div`
	text-align: center;
	max-width: 600px;
	padding: 3rem;
	border-radius: 8px;
	background: #f5f5f5;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Titulo = styled.h1`
	color: #333;
	font-size: 2rem;
	margin-bottom: 2rem;
	font-weight: 600;
`;

const Mensagem = styled.p`
	color: #666;
	font-size: 1.1rem;
	margin-bottom: 2rem;
	line-height: 1.6;
`;

const CodigoContainer = styled.div`
	background: white;
	border: 2px solid #007bff;
	border-radius: 8px;
	padding: 1.5rem;
	margin: 2rem 0;
	word-break: break-all;
`;

const CodigoTexto = styled.p`
	color: #007bff;
	font-size: 1.3rem;
	font-weight: 600;
	font-family: "Courier New", monospace;
	margin: 0;
`;

const BotaoCopiar = styled.button`
	background-color: #007bff;
	color: white;
	border: none;
	padding: 0.8rem 2rem;
	border-radius: 4px;
	font-size: 1rem;
	cursor: pointer;
	transition: background-color 0.3s ease;
	margin-top: 1rem;

	&:hover {
		background-color: #0056b3;
	}

	&:active {
		background-color: #003f8f;
	}
`;

const MensagemCopia = styled.p`
	color: #28a745;
	font-size: 0.9rem;
	margin-top: 0.5rem;
	display: ${(props) => (props.$visivel ? "block" : "none")};
`;

export default function PageBling() {
	const [searchParams] = useSearchParams();
	const codigo = searchParams.get("code");
	const [copiado, setCopiado] = React.useState(false);

	const handleCopiar = () => {
		if (codigo) {
			navigator.clipboard.writeText(codigo);
			setCopiado(true);
			setTimeout(() => setCopiado(false), 2000);
		}
	};

	return (
		<PageLayout>
			<ContainerBling>
				<ConteudoCentralizado>
					<Titulo>✓ Sua sessão foi autorizada!</Titulo>
					<Mensagem>Copie o código abaixo e insira no E-sync para vincular sua conta Bling ao aplicativo</Mensagem>

					{codigo ? (
						<>
							<CodigoContainer>
								<CodigoTexto>{codigo}</CodigoTexto>
							</CodigoContainer>
							<BotaoCopiar onClick={handleCopiar}>
								Copiar Código
							</BotaoCopiar>
							<MensagemCopia $visivel={copiado}>
								✓ Código copiado para a área de transferência!
							</MensagemCopia>
						</>
					) : (
						<Mensagem style={{ color: "#ff6b6b" }}>
							Nenhum código foi fornecido. Verifique o link de retorno.
						</Mensagem>
					)}
				</ConteudoCentralizado>
			</ContainerBling>
		</PageLayout>
	);
}
